<template>
  <div class="org-picker-mask" @keydown.esc.prevent="cancel">
    <section ref="dialog" class="org-picker" role="dialog" aria-modal="true" aria-labelledby="org-picker-title" tabindex="-1" @keydown.tab="trapTab">
      <h2 id="org-picker-title">{{ title }}</h2>
      <p>该手机号关联了多个机构，请选择当前要管理的机构。</p>
      <div class="org-options" aria-label="可管理的机构">
        <button v-for="item in organizations" :key="item.orgId" type="button" :class="{ selected: String(value) === String(item.orgId) }" :aria-pressed="String(value) === String(item.orgId)" :disabled="busy" @click="$emit('select', item.orgId)">
          <span><strong>{{ item.orgName || `机构 ${item.orgId}` }}</strong><small>机构编号 {{ item.orgId }}</small></span>
          <i aria-hidden="true">{{ String(value) === String(item.orgId) ? '✓' : '' }}</i>
        </button>
      </div>
      <div class="org-actions"><button v-if="cancelable" type="button" :disabled="busy" @click="cancel">取消</button><button type="button" class="primary" :disabled="busy || !value" @click="$emit('confirm')">{{ busy ? '切换中…' : '确认进入' }}</button></div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SanGaoStaffOrgPicker',
  props: {
    organizations: { type: Array, default: () => [] },
    value: { type: [String, Number], default: null },
    title: { type: String, default: '选择机构' },
    busy: { type: Boolean, default: false },
    cancelable: { type: Boolean, default: false },
  },
  mounted() { this.$nextTick(() => this.$refs.dialog && this.$refs.dialog.focus()); },
  methods: {
    cancel() { if (this.cancelable && !this.busy) this.$emit('cancel'); },
    trapTab(event) {
      const buttons = Array.from(this.$refs.dialog.querySelectorAll('button:not([disabled])'));
      if (!buttons.length) { event.preventDefault(); return; }
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.$refs.dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    },
  },
};
</script>

<style scoped>
.org-picker-mask { position: fixed; z-index: 3000; inset: 0; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(14, 37, 60, .62); }
.org-picker { width: min(100%, 460px); max-height: min(78vh, 660px); display: flex; flex-direction: column; padding: 26px; border-radius: 18px; background: #fff; color: #183c59; box-shadow: 0 20px 60px rgba(5, 39, 70, .28); outline: none; }
.org-picker h2 { margin: 0; font-size: 22px; }
.org-picker p { margin: 9px 0 18px; color: #71869a; font-size: 14px; line-height: 1.55; }
.org-options { min-height: 0; overflow-y: auto; display: grid; gap: 10px; padding: 2px; }
.org-options button { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 66px; padding: 11px 14px; border: 1px solid #dce8f2; border-radius: 12px; background: #f8fbfe; color: #204968; text-align: left; cursor: pointer; }
.org-options button.selected { border-color: #1685d6; background: #edf7ff; }
.org-options strong, .org-options small { display: block; }
.org-options strong { font-size: 16px; }
.org-options small { margin-top: 3px; color: #7790a5; font-size: 12px; }
.org-options i { flex: 0 0 23px; height: 23px; border: 1px solid #a8cce9; border-radius: 50%; color: #fff; font-size: 15px; font-style: normal; line-height: 21px; text-align: center; }
.org-options .selected i { border-color: #1685d6; background: #1685d6; }
.org-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }
.org-actions button { min-width: 84px; min-height: 42px; padding: 0 16px; border: 1px solid #d7e5f0; border-radius: 9px; background: #fff; color: #365b77; cursor: pointer; }
.org-actions .primary { border-color: #1685d6; background: #1685d6; color: #fff; }
.org-actions button:disabled { opacity: .55; cursor: not-allowed; }
@media (max-width: 600px) { .org-picker { padding: 22px 18px; } .org-picker h2 { font-size: 20px; } }
</style>
